/* blocks */
import PageHero from '@/cmp/organism/PageHero/PageHero'
import PageHeroVideo from '../VideoMarketing/components/PageHero/PageHero'
import CustomerLogo from '@/cmp/organism/CustomerLogo/CustomerLogo'
import ValueOutcomes from '@/cmp/organism/ValueOutcomes/ValueOutcomes'
import ServicePicker from './components/ServicePicker/ServicePicker'
import ContentTypeFeatures from '@/cmp/organism/ContentTypeFeatures/ContentTypeFeatures'
import IndustriesAndUseCases from '../VideoMarketing/components/IndustriesAndUseCases/IndustriesAndUseCases'
import AllVideoFormats from '../VideoMarketing/components/AllVideoFormats/AllVideoFormats'
import PepperAdvantage from '../VideoMarketing/components/PepperAdvantage/PepperAdvantage'
import Portfolio from '../VideoMarketing/components/Portfolio/Portfolio'
import MoreCaseStudies from '../CaseStudy/components/MoreCaseStudies/MoreCaseStudies'
import MarketingGoals from '../VideoMarketing/components/MarketingGoals/MarketingGoals'
import FAQNew from '@/cmp/organism/FAQNew/FAQNew'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* styles */
import styles from './_.module.css'

interface Props {
  data: CategoryPage
}

function ContentTypes({ data }: Props): JSX.Element {
  return (
    <>
      {data.slug.includes('video') ? (
        <PageHeroVideo
          primaryHeadline={data.hero.title}
          subText={data.hero.description}
          primaryCta={data.hero.primaryCta}
          heroVideo={data.hero.image?.data}
          showReelVideo={data.pepperShowReelVideo.data}
        />
      ) : (
        <PageHero
          layout="left"
          class={styles.pageHero}
          primaryHeadline={data.hero.title}
          subText={data.hero.description}
          primaryCta={data.hero.primaryCta}
          secondaryCta={data.hero.secondaryCta}
          image={data.hero.image?.data?.attributes}
          videoLink={data.hero.videoLink}
        />
      )}

      {data.brandList.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brandList.title}
          brands={data.brandList.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
        />
      ) : null}

      {data.goalList.length > 0 ? (
        <ValueOutcomes
          layout="descriptive"
          theme="dark"
          title={data.goalTitle}
          list={data.goalList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.services.length > 0 && data.type !== 'video' ? (
        <ServicePicker
          title={data.servicesTitle}
          description={data.servicesDescription}
          services={data.services}
        />
      ) : null}

      {data.contentTypeFeatureList.length > 0 ? (
        <ContentTypeFeatures
          title={data.contentTypeFeatureTitle}
          list={data.contentTypeFeatureList.map(i => ({
            id: i.id,
            link: i.link,
            bgColor: i.color,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes,
            tag: i.additionalFields?.tag as string | null,
            color: i.additionalFields?.color as string | null
          }))}
        />
      ) : null}

      {data.industriesAndUseCaseList.data.length > 0 ? (
        <IndustriesAndUseCases
          title={data.industriesAndUseCaseTitle}
          description={data.industriesAndUseCaseDescription}
          lists={data.industriesAndUseCaseList.data.map(item => ({
            url: item.attributes.url,
            alternativeText: item.attributes.alternativeText,
            width: item.attributes.width,
            height: item.attributes.height
          }))}
        />
      ) : null}

      {data.allVideoFormatList.length > 0 ? (
        <AllVideoFormats
          title={data.allVideoFormatTItle}
          bgImage={data.allVideoFormatBgImage.data.attributes}
          lists={data.allVideoFormatList.map(item => ({
            title: item.title ?? '',
            description: item.description ?? '',
            color: item.color ?? '',
            image: item.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.pepperAdvantageList.length > 0 ? (
        <PepperAdvantage
          title={data.pepperAdvantageTitle}
          lists={data.pepperAdvantageList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.portfolioList.length > 0 ? (
        <Portfolio
          title={data.portfolioTitle}
          bgImage={data.portfolioBgImage.data.attributes}
          lists={data.portfolioList.map(i => ({
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes,
            videoUrl: i.multimedia?.url ?? ''
          }))}
        />
      ) : null}

      {data.marketingGoalsList.length > 0 ? (
        <MarketingGoals
          title={data.marketingGoalsTitle}
          lists={data.marketingGoalsList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            cta: i.link,
            image: i.multimedia?.media?.data?.attributes,
            color: i.color
          }))}
        />
      ) : null}

      {data.moreCaseStudies.data.length > 0 ? (
        <MoreCaseStudies
          title={data.caseStudyTitle}
          data={data.moreCaseStudies.data}
          isHomePage={true}
          showViewMore={false}
        />
      ) : null}

      {data.faqs.length > 0 ? (
        <FAQNew title={data.faqTitle} list={data.faqs} />
      ) : null}

      {data.footerCta ? (
        <FooterCta
          headline={data.footerCta.title}
          mode="full_width"
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
        />
      ) : null}
    </>
  )
}

export default ContentTypes
